/**
 * Quais análises já estão em uso e, por isso, não podem ser escolhidas de novo
 * no modal de "Nova análise".
 *
 * Uma mesma análise (profundidade + exame) só faz sentido uma vez por OS: repetir
 * geraria dois grupos de pontos para o mesmo item, com cobrança duplicada. O modal
 * de cópia já bloqueia assim (`disabledItens`); aqui a regra é a mesma.
 */

interface AnaliseComCod {
    cod_analise?: number
    id?: string | number
    [key: string]: any
}

/**
 * Cods de análise a desabilitar no select.
 *
 * Considera tanto as análises já salvas nos cards quanto as adicionadas dentro
 * da sessão atual do modal — ambas ocupam o lugar daquela análise na OS.
 *
 * @param id_em_edicao quando o modal foi aberto para EDITAR um grupo existente,
 * a análise dele precisa continuar selecionável: bloqueá-la impediria o usuário
 * de salvar a própria edição.
 */
export function obterAnalisesEmUso(
    analises_salvas: AnaliseComCod[] = [],
    adicionadas_na_sessao: AnaliseComCod[] = [],
    id_em_edicao?: string | number | null
): number[] {
    const emUso = new Set<number>()

    const registrar = (lista: AnaliseComCod[]) => {
        ;(lista ?? []).forEach((item) => {
            if (id_em_edicao != null && item?.id === id_em_edicao) return

            const cod = Number(item?.cod_analise)
            if (Number.isFinite(cod)) emUso.add(cod)
        })
    }

    registrar(analises_salvas)
    registrar(adicionadas_na_sessao)

    return Array.from(emUso)
}
